export default __webpack_public_path__ + "static/media/utility.f4739fbc.svg";